const { Component } = require('react')
const router = require('app/services/router')
const Trans = require('app/components/trans/Trans')

class AlcoholWarning extends Component {
  static get defaultProps () {
    return {
      floating: false,
      isWideStep: false
    }
  }

  get baseClass () {
    if (this.props.floating) {
      return 'alcohol-warning-float'
    }

    return 'alcohol-warning'
  }

  get class () {
    if (this.props.isWideStep) {
      return this.baseClass + ' wide'
    }

    return this.baseClass
  }

  render () {
    return (
      <img className={this.class} src={router.url('img/alcohol-warning.png')} alt={translate('Skiltning om salg af tobak og alkohol')} />
    )
  }
}

module.exports = AlcoholWarning
